module.exports = __webpack_public_path__ + "img/2.f86f0157.jpg";